"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var getIconComponent_1 = __importDefault(require("./getIconComponent"));
var Icon = function (_a) {
    var classes = _a.classes, _b = _a.color, color = _b === void 0 ? 'inherit' : _b, _c = _a.component, component = _c === void 0 ? 'svg' : _c, _d = _a.fontSize, fontSize = _d === void 0 ? 'medium' : _d, kind = _a.kind, _e = _a.style, style = _e === void 0 ? {} : _e;
    var IconComponent = (0, getIconComponent_1.default)(kind);
    return (IconComponent
        ? react_1.default.createElement(IconComponent, { classes: classes, color: color, component: component, fontSize: fontSize, style: style }) : null);
};
exports.default = Icon;
